import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { BrandLogoMark } from "./BrandLogoMark";
import { useAuth } from "@/contexts/AuthContext";
import { useNotifications } from "@/hooks/useNotifications";
import { useSidebarActiveContext } from "@/contexts/SidebarActiveContext";
import { getAccountMenuConfig } from "./account-menu/accountMenuNavGroups";
import { MobileAccountSheet } from "./account-menu/MobileAccountSheet";

function NigeriaFlagDisc() {
  return (
    <span
      className="h-4 w-4 shrink-0 overflow-hidden rounded-full block ring-1 ring-inset ring-[#1E1B4B]/[0.18]"
      aria-label="Nigeria"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" className="block">
        <rect width="8" height="24" fill="#008751" />
        <rect x="8" width="8" height="24" fill="#FFFFFF" />
        <rect x="16" width="8" height="24" fill="#008751" />
      </svg>
    </span>
  );
}

export function PublicMobileHeader() {
  const { user, userRole } = useAuth();
  const { unreadCount } = useNotifications();
  const { dashboardPath } = getAccountMenuConfig(userRole, unreadCount);
  const { hideMobileHeader } = useSidebarActiveContext();

  // The compact artist/track feed replaces this bar with its own floating
  // back control and extends full-bleed to the top of the viewport.
  if (hideMobileHeader) return null;

  return (
    <div className="lg:hidden flex items-center justify-between h-[62px] px-[18px] bg-white border-b border-[#1E1B4B]/10">
      <Link to="/" className="flex items-center gap-2.5">
        <BrandLogoMark
          className="h-[26px] w-[26px] rounded-md object-cover"
          iconSize={14}
        />
        <span className="font-archivo font-black text-lg text-[#1E1B4B] tracking-tight">
          PayStreem
        </span>
        <NigeriaFlagDisc />
      </Link>
      {user && (
        <div className="flex items-center gap-1">
          <Link
            to={`${dashboardPath}?tab=notifications`}
            className="relative flex h-11 w-11 items-center justify-center"
            aria-label="Notifications"
          >
            <Bell size={21} color="#1E1B4B" strokeWidth={1.5} />
            {unreadCount > 0 && (
              <span className="absolute top-2 right-2 min-w-[15px] h-[15px] px-1 rounded-full bg-[#5A31D8] text-white font-jetbrains font-bold text-[9px] leading-[15px] text-center">
                {unreadCount}
              </span>
            )}
          </Link>
          <MobileAccountSheet />
        </div>
      )}
    </div>
  );
}
